import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PlayerAvatar } from "./PlayerAvatar";
import { Star } from "lucide-react";

export function PagellaView({ playersMap, onSelectPlayer }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/votes/season").then((r) => setRows(r.data)).catch(() => setRows([]));
  }, []);

  return (
    <div className="space-y-3" data-testid="pagella-view">
      <div>
        <div className="text-xs font-semibold uppercase tracking-[0.2em] text-amber-400">Voti dei compagni e avversari</div>
        <h3 className="font-display font-extrabold uppercase tracking-tight text-2xl text-white">Classifica Pagella</h3>
      </div>
      {rows && rows.length === 0 && (
        <p className="text-sm text-slate-500" data-testid="pagella-empty">Ancora nessun voto: si vota dalla scheda di ogni incontro in Risultati.</p>
      )}
      <div className="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {(rows || []).map((r, i) => (
          <button key={r.player_id} data-testid={`pagella-row-${r.player_id}`} onClick={() => onSelectPlayer(r.player_id)}
            className="ap-card p-3 flex items-center gap-3 text-left hover:border-amber-400/40 transition-colors">
            <span className="font-mono font-black text-slate-500 w-5">{i + 1}</span>
            <PlayerAvatar id={r.player_id} name={playersMap[r.player_id]?.name} size={32} />
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold text-white truncate">{playersMap[r.player_id]?.name}</div>
              <div className="text-[11px] text-slate-500">{r.count} {r.count === 1 ? "voto" : "voti"} · {r.matches} {r.matches === 1 ? "incontro" : "incontri"}</div>
            </div>
            <span className="flex items-center gap-1 font-mono font-black text-lg text-amber-400">
              <Star className="w-4 h-4 fill-amber-400" />{r.avg.toFixed(1)}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
